<template>
    <router-link
        :to="{ name: 'folder.view', params: { id: folder.id, slug: folder.slug } }"
        class="border-t last:border-b border-black block"
    >
        <div>
            <!-- MOBILE -->
            <div class="p-4 md:hidden">
                <div class="flex">
                    <div class="min-w-[100px] text-2xl">
                        <p v-if="folder.date">{{ formatDate(folder.date, "DD.MM") }}</p>
                        <p v-if="folder.date" class="text-grey">{{ formatDate(folder.date, "YY") }}</p>
                    </div>

                    <div class="text-2xl">
                        {{ folder.title }}
                    </div>
                </div>

                <div class="flex justify-end">
                    <img class="w-28 h-28 rounded-md shrink-0 object-cover" :src="folder.public_cover_path" alt="">
                </div>

                <p class="line-clamp-3 mt-10" v-html="folder.intro"></p>
            </div>
            <!-- END MOBILE -->

            <!-- DESKTOP -->
            <div
                class="hidden md:flex hover:bg-pink group hover:!text-white transition duration-200 ease-in-out hover:cursor-pointer">
                <div class="border-r border-black w-1/3">
                    <div class="flex justify-between px-4 lg:px-12 py-6 h-full">
                        <img class="w-28 h-28 rounded-md shrink-0 object-cover aspect-square"
                             :src="folder.public_cover_path" alt="">
                        <div class="text-3xl text-right">
                            <p v-if="folder.date">{{ formatDate(folder.date, "DD.MM") }}</p>
                            <p v-if="folder.date" class="text-grey">{{ formatDate(folder.date, "YY") }}</p>
                        </div>
                    </div>
                </div>
                <div class="w-2/3">
                    <div class="px-4 lg:px-12 py-6">
                        <div class="flex justify-between">
                            <div class="text-2xl w-1/2 pr-12 shrink-0">
                                {{ folder.title }}
                            </div>
                            <div>
                                <p class="line-clamp-5" v-html="folder.intro"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END DESKTOP -->
        </div>
    </router-link>
</template>

<script>
import {formatDate} from "../../../utils/formatDate";

export default {
    name: 'MoleculeCardFolder',
    props: {
        folder: {
            required: true,
            type: Object
        },
    },
    methods: {
        formatDate,
    }
}
</script>
